import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { CommonService } from '../../../../shared/common.service';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';
import { DividendsComponentService } from './service/dividends-component.service';

@Component({
  selector: 'app-dividends',
  templateUrl: './dividends.component.html',
  styleUrls: ['./dividends.component.scss']
})
export class DividendsComponent implements OnInit {
  Dividends: FormGroup;
  isJump: any;
  NormalRoutng: boolean;
  showBubbledata: any;

  constructor(private formbuilder: FormBuilder, private service: DividendsComponentService, public commonService: CommonService, private router: Router, private sidenav: SideNavService) {

  }
  ngOnInit() {
    debugger
    this.commonService.getIncomeStatementsHeaders();
    this.Createformgroup();
      this.Getdata();
      this.clearfield();
    this.isJump = localStorage.getItem('isJump')

    //this.commonService.Showbubble.subscribe((data) => {
    //  if (data) {
        this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data) => {
          this.commonService.showBubble = data[0].ImportStatus
          if (this.commonService.showBubble) {
            this.sidenav.setShowBubble(true)
            this.Getdata_LY()
          }
        })
    //  }
    //  else {
    //    this.showBubbledata = null
    //  }
    //})

    if (localStorage.getItem("SubmitStatus") == "true")
      this.Dividends.disable()
  }
  Createformgroup() {
    this.Dividends = this.formbuilder.group({
      AdditionalInformation: new FormControl(),
      PageName: new FormControl(),
      APPeriodId: new FormControl(),
      CreatedBy: new FormControl(localStorage.getItem('LoginuserId')),
      CreatedDate: new FormControl(),
      ModifiedBy: new FormControl(),
      ModifiedDate: new FormControl(),
    })
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.Dividends.reset()
      }
    })
  }
  
  Savemethod() {
    debugger;
    var data = this.Dividends.getRawValue();
    data.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    data.PageName = "Dividends";
    this.service.insertsinglestatementdetails(data).subscribe((data: any) => {
      this.Dividends.markAsPristine();
      if (this.NormalRoutng)
        return true;
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("Dividends", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.router.navigate(['/notes'])
      else if (nextPage == 'dividends') {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.router.navigate([nextPage]);
      }
      else {
        this.router.navigate([nextPage]);
      }
    })
  }
  Back() {
    this.Dividends.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Dividends", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }
  Getdata() {
    debugger;
    var id = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    var PageName = "Dividends";
    this.service.Getsinglestatementdetails(id, PageName).subscribe((data: any) => {
      this.Dividends.patchValue(data);
      this.commonService.getNotesData();
    })
  }
  Getdata_LY() {
    debugger;
    var id = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    var PageName = "Dividends";
    this.service.Getsinglestatementdetails_LY(id, PageName).subscribe((data: any) => {
      this.showBubbledata=data;
    })
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.Dividends.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          this.Savemethod();
          return true;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }

}
